module.exports = __webpack_public_path__ + "static/media/2.b6b0762c.png";